import React from 'react'
import styled from '@emotion/styled'
import {useSeoSRPMetadata} from 'hooks/useSeoSRPMetadata'

import {Box} from '@vio/atlas/helpers/Box'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {Text} from '@vio/atlas/Text'

const CapitalizedText = styled(Text)`
  &::first-letter {
    text-transform: uppercase;
  }
`

export const SeoHeading: React.FC = () => {
  const metaSeo = useSeoSRPMetadata()
  const {isMobile} = useDeviceLayout()

  if (!metaSeo) {
    return null
  }

  return (
    <Box
      padding="s400"
      paddingLeft={isMobile ? 's000' : 's400'}
      paddingRight={isMobile ? 's000' : 's400'}
    >
      <CapitalizedText variant={isMobile ? 'titleM' : 'titleL'} tag="h1">
        {metaSeo.heading}
      </CapitalizedText>
    </Box>
  )
}
